// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__3Tp09","content":"layout_content__3TOmO","logo_overlay":"layout_logo_overlay__Zk4U_"};